import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

export const PasswordInput = ({ "data-testid": testId, className = "", ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...props} data-testid={testId} type={show ? "text" : "password"} className={`pr-10 ${className}`}/>
      <button type="button" data-testid={`${testId}-toggle`} onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-[color:var(--text-muted)] hover:text-[color:var(--primary)] transition-colors">
        {show ? <EyeOff size={16}/> : <Eye size={16}/>}
      </button>
    </div>
  );
};
